import { render, staticRenderFns } from "./IndexPromotions.vue?vue&type=template&id=6af569b2&scoped=true&"
import script from "./IndexPromotions.vue?vue&type=script&lang=js&"
export * from "./IndexPromotions.vue?vue&type=script&lang=js&"
import style0 from "./IndexPromotions.vue?vue&type=style&index=0&id=6af569b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af569b2",
  null
  
)

export default component.exports